"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CheckoutTransfer["default"];
  }
});
var _CheckoutTransfer = _interopRequireDefault(require("./CheckoutTransfer"));